(ns rothko.audio.mini-player.component
  (:require ["react" :refer [createRef]]
            [reagent.core :as reagent]
            [rothko.button.component :refer [button]]
            [rothko.icon.component :refer [icon]]
            [rothko.icon-animated.component :refer [spinner]]))

(defn- start-playback!
  [audio-element state-ratom]
  (set! (.-currentTime audio-element) 0)
  (.play audio-element)
  (swap! state-ratom assoc :playing? true))

(defn- pause-playback!
  [audio-element state-ratom]
  (.pause audio-element)
  (set! (.-currentTime audio-element) 0)
  (swap! state-ratom assoc :playing? false))

(defn- toggle-playback!
  [{:keys [id on-audio-state-change] :as props} audio-element state-ratom]
  (let [{:keys [loaded? playing?]} @state-ratom]
    (when audio-element
      (let [audio-paused? (.-paused audio-element)]
        (if audio-paused?
          (start-playback! audio-element state-ratom)
          (pause-playback! audio-element state-ratom))
        (when on-audio-state-change
          (let [next-state @state-ratom]
            (on-audio-state-change {:id id
                                    :loaded? (:loaded? next-state)
                                    :playing? (:playing? next-state)
                                    :ready-state (.-readyState audio-element)})))))))

(defn mini-player
  [props & children]
  (let [audio-element-ref (createRef)
        state-ratom (reagent/atom {:loaded? false
                                   :playing? false})]
    (reagent/create-class
     {:display-name "audio-mini-player"
      :component-will-unmount (fn [_]
                                (let [{:keys [playing?]} @state-ratom
                                      audio-element (.-current audio-element-ref)]
                                  (when playing?
                                    (set! (.-muted audio-element) true)
                                    (pause-playback! audio-element state-ratom))))
      :reagent-render
      (fn [{:keys [appearance aria-pause-text aria-play-text id label on-play on-click src]
            :or {on-play (constantly :noop)
                 on-click (constantly :noop)}
            :as props}
           & children]
        (let [{:keys [loaded? playing?]} @state-ratom
              on-ended #(swap! state-ratom assoc :playing? false)
              on-loaded #(swap! state-ratom assoc :loaded? true)
              on-play-handler (fn []
                                (swap! state-ratom assoc :playing? true)
                                (on-play)
                                ;; TODO when incorporating into sandi needs to be passed in as on-play
                                ;; (rf/dispatch [::informant/log :question-playback-started {:audio-description id}])
                                )
              on-click-handler (fn [event]
                                 (.stopPropagation event)
                                 (toggle-playback! props (.-current audio-element-ref) state-ratom)
                                 (on-click)
                                 ;; TODO when incorporating into sandi needs to be passed in as on-click
                                 ;; (rf/dispatch [::informant/log :toggle-question-playback {:audio-description id :playing? playing?}])
                                 )]
          [:div.audio-mini-player {:class appearance}
           [:audio {:onEnded on-ended
                    ;; OnLoadStart event necessary for player to load on mobile browser.
                    :onLoadStart on-loaded
                    :onCanPlayThrough on-loaded
                    :on-play on-play-handler
                    :src src
                    :ref audio-element-ref}]
           (if loaded?
             [button {:appearance #{:link}
                      :aria-label (if playing?
                                    aria-pause-text
                                    aria-play-text)
                      :on-click on-click-handler}
              [icon {:icon (if playing? :volume-up :volume-off)
                     :class [:audio-mini-player__icon]}]
              (if children
                (into [:span] children)
                [:span.audio-mini-player__text label])]
             [spinner {:size 20}])]))})))
